import { defineFcm } from '../shared/factory';

export const FCM_MAINTENANCE_BANNER = defineFcm('maintenance_banner').asString().withDefault(undefined).toConfig({
	owner: 'squad-site-platform',
	scope: 'corgi-front-end',
	context: 'All pages',
	description: 'Use to display a custom maintenance message',
});
